{
  "wallboard": {
    "instances_count": "{count} eintak | {count} eintök",
    "label": "Wallboard"
  }
}
